import { render } from "./attentionLogs.vue?vue&type=template&id=36fdf35f&ts=true"
import script from "./attentionLogs.vue?vue&type=script&lang=ts"
export * from "./attentionLogs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__